import * as React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import animation from "common/assets/animation.json";
import * as theme from "./theme.scss";

const MainLoader = () => {
	return (
		<div className={theme.container}>
			<Player
				autoplay
				loop
				src={animation}
				style={{ width: "200px", height: "200px" }}
			/>
		</div>
	);
};

export default MainLoader;
